export enum SelectionActionType {
  SELECTION_TOGGLE_SELECTION = 'SELECTION_TOGGLE_SELECTION',
  SELECTION_TOGGLE_ALL = 'SELECTION_TOGGLE_ALL',
  SELECTION_RESET = 'SELECTION_RESET'
}
